import { render, staticRenderFns } from "./IntegrationFutureshop.vue?vue&type=template&id=7cca32ec&scoped=true&"
import script from "./IntegrationFutureshop.vue?vue&type=script&lang=ts&"
export * from "./IntegrationFutureshop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cca32ec",
  null
  
)

export default component.exports